import { LogglyTracker } from 'loggly-jslogger';

const logger = new LogglyTracker();
logger.push({
  'logglyKey': process.env.REACT_APP_LOGGLY_CUSTOMER_TOKEN,
  'tag': 'RadioSDK'
});

export default logger;